import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { MaterialModule } from '../../app/material.module';
import { InlineEditComponent } from './inline-edit.component';
import { NumberDirectiveModule } from '../directives/number-directive/number-directive.module';

@NgModule({
  declarations: [InlineEditComponent],
  imports: [CommonModule, FormsModule, MaterialModule, UzurvDirectivesModule, UzurvPipesModule, NumberDirectiveModule],
  exports: [InlineEditComponent]
})
export class InlineEditComponentModule {}
